{
  "version": 1,
  "asset_id": "718292f8-59b6-45e7-9adb-45abd70f4183",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/718292f8-59b6-45e7-9adb-45abd70f4183/umair-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/718292f8-59b6-45e7-9adb-45abd70f4183/umair-640.avif",
  "original_filename": "umair-640.avif",
  "size": 7121,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:41Z"
}
